module.exports = __webpack_public_path__ + "static/media/msy.185da73b.jpg";